import React, { useCallback, useEffect, useRef, useState } from "react";
import ActividadService from "../../services/Iperc/ActividadService";
import { IRequestComboActividadPorEquipo } from "../../Interfaces/IIPERC";
import { IComboBox, IComboBoxOption } from "@fluentui/react";

export const useComboActividadPorEquipo = () => {
  const [dataComboActividad, setDataComboActividad] = useState<
    IComboBoxOption[]
  >([]);
  const [filter, setFilter] = useState<IRequestComboActividadPorEquipo>({
    equipoId: null,
    search: "",
  });

  const onChangeEquipo = (e, o) => {
    if (e !== undefined) {
      if (o?.key) {
        setFilter({ ...filter, equipoId: o.key });
      }
    }
  };

  const comboBoxRefActividad = useRef<IComboBox>(null);
  const _openOptionComboActiivdad = useCallback(() => {
    comboBoxRefActividad.current?.focus(true);
  }, []);
  const onClickComboBoxActividad = () => {
    comboBoxRefActividad.current?.focus(true);
  };
  const _onKeyUpSeaechComboActividad = (
    event: React.KeyboardEvent<IComboBox>
  ) => {
    if (event.code === "Escape") {
      comboBoxRefActividad.current?.focus(false);
    } else {
      _openOptionComboActiivdad();
      let { value } = event?.target as HTMLInputElement;
      setFilter({ ...filter, search: value });
    }
  };

  const postComboActivdades = () => {
    ActividadService.postComboActividadPorEquipo(filter).then((res) => {
      if (res.status === 200) {
        setDataComboActividad(res.data);
      }
    });
  };

  useEffect(() => {
    postComboActivdades();
  }, [filter]);

  return {
    dataComboActividad,
    onClickComboBoxActividad,
    _onKeyUpSeaechComboActividad,
    onChangeEquipo,
    comboBoxRefActividad,
  };
};
